import React from 'react';
import { Section } from './Section';
import { BookOpen, Monitor, Droplets, DoorOpen } from 'lucide-react';
export const Entregables = () => {
  const items = [{
    icon: BookOpen,
    title: 'Guía Maestra "Blindaje 101"',
    desc: 'El manual paso a paso para dejar de ser una esponja y ser un espejo.'
  }, {
    icon: Monitor,
    title: 'Protocolo del Escritorio Protegido',
    desc: 'Cómo limpiar tu espacio de trabajo sin prender un solo sahumerio.'
  }, {
    icon: Droplets,
    title: 'Técnica de la Ducha Seca',
    desc: 'El movimiento físico exacto para sacarte la "mugre" energética antes de subir al colectivo.'
  }, {
    icon: DoorOpen,
    title: 'Checklist del Umbral Sagrado',
    desc: '3 pasos para entrar a tu casa y que la oficina se quede afuera de la llave.'
  }];
  return <Section className="bg-navy-900/30 border-y border-gold/10" data-id="element-38">
      <div className="text-center mb-16" data-id="element-39">
        <h2 className="text-3xl md:text-5xl font-serif mb-4" data-id="element-40">
          Lo que <span className="text-gold italic" data-id="element-41">recibís</span> hoy
        </h2>
        <p className="text-gray-400" data-id="element-42">Tu botiquín digital de acceso inmediato</p>
      </div>

      <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-43">
        {items.map((item, i) => <div key={i} className="group relative p-8 border border-gold/20 bg-navy-800/50 hover:bg-navy-800 transition-all duration-300 rounded-sm overflow-hidden" data-id="element-44">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gold/5 rounded-bl-full -mr-16 -mt-16 transition-transform group-hover:scale-110" data-id="element-45" />

            <div className="relative z-10" data-id="element-46">
              <div className="w-12 h-12 rounded-full border border-gold/30 flex items-center justify-center text-gold mb-6 group-hover:bg-gold/10 transition-colors" data-id="element-47">
                <item.icon size={24} strokeWidth={1.5} data-id="element-48" />
              </div>
              <h3 className="text-xl font-serif font-bold text-offwhite mb-3" data-id="element-49">
                {item.title}
              </h3>
              <p className="text-gray-400 font-light leading-relaxed" data-id="element-50">
                {item.desc}
              </p>
            </div>
          </div>)}
      </div>
    </Section>;
};